import { render } from "./Parcel.vue?vue&type=template&id=0547e73c"
import script from "./Parcel.vue?vue&type=script&lang=js"
export * from "./Parcel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__